import Component from "../classes/Component";
import $ from 'jquery';

export default class Footer extends Component {
  constructor() {
    super({});
    this.element = [
      $("[data-components-footer]"),
    ];
    this.init();
  }
  init() {
    if (this.element) {
      this.openMenuMobile();
    }
  }
  openMenuMobile() {
    $('.footer__nav .arrow').click(function(){
      $(this).parent().toggleClass("is-active");
      $(this).next().slideToggle(200);
    });
  }
}
